import { use, useState } from 'react'
import { useEventListener } from 'usehooks-ts'
import { FlowerCollectionProduct } from '@/api-client/data-contracts'
import clear1 from './images/clear1.jpg'
import clear2 from './images/clear2.jpg'
import clear3 from './images/clear3.jpg'
import clear4 from './images/clear4.jpg'
import clear5 from './images/clear5.jpg'
import clear6 from './images/clear6.jpg'
import gray1 from './images/gray1.jpg'
import gray2 from './images/gray2.jpg'
import gray3 from './images/gray3.jpg'
import gray4 from './images/gray4.jpg'
import iron1 from './images/iron1.jpg'
import iron2 from './images/iron2.jpg'
import iron3 from './images/iron3.jpg'
import iron4 from './images/iron4.jpg'
import iron5 from './images/iron5.jpg'
import iron6 from './images/iron6.jpg'

type Props = {
  inBulkPurchasables: Promise<FlowerCollectionProduct[]>
}

export const VasesSection: React.FC<Props> = ({ inBulkPurchasables }) => {
  const [selectedVase, setSelectedVase] = useState(null)
  const products = use(inBulkPurchasables)

  const productData = [
    {
      name: 'ファゴット（クリア）',
      popular: true,
      price: '3,630（税込）',
      discountPrice: '2,904（税込）',
      desc: '枝ものはもちろん、お花を飾るのにもぴったり。',
      alt: '花器ファゴット クリア',
      images: [clear1, clear2, clear3, clear4, clear5, clear6],
      detail:
        'ファゴットの一番の魅力は、大きな枝も飾れるところ。底の部分が広く、しっかりと厚みがあるので倒れる心配がありません。大ぶりの枝ものも難なく飾ることができます。\n\n口の部分できゅっときれいにまとまるので、ざっくりラフに飾ってもおしゃれな雰囲気に。\n\nまさにお部屋の主役を飾るのにぴったりの花器。これひとつで枝も花も楽しめる。シンプルだから主張しすぎず、植物を引き立ててくれます。',
      size: '高さ20cm 口の直径7.2cm 底面の直径16.7cm',
      material: 'ガラス',
      notes: ['ハンドメイドの製品のため、多少の気泡・巻き線が入る場合があります', '製法上、発色に個体差があります'],
    },
    {
      name: 'ファゴット（グレー）',
      price: '4,840（税込）',
      discountPrice: '3,872（税込）',
      desc: '落ち着いたグレーが枝の美しさを引き立てます。',
      alt: '花器ファゴット グレー',
      images: [gray1, gray2, gray3, gray4],
      detail:
        'ファゴットの一番の魅力は、大きな枝も飾れるところ。底の部分が広く、しっかりと厚みがあるので倒れる心配がありません。大ぶりの枝ものも難なく飾ることができます。\n\n口の部分できゅっときれいにまとまるので、ざっくりラフに飾ってもおしゃれな雰囲気に。\n\nまさにお部屋の主役を飾るのにぴったりの花器。これひとつで枝も花も楽しめる。シンプルだから主張しすぎず、植物を引き立ててくれます。',
      size: '高さ20cm 口の直径7.2cm 底面の直径16.7cm',
      material: 'ガラス',
      notes: ['ハンドメイドの製品のため、多少の気泡・巻き線が入る場合があります', '製法上、発色に個体差があります'],
    },
    {
      name: '大きな枝を飾れるアイアンスタンド',
      price: '6,270（税込）',
      discountPrice: '5,016（税込）',
      desc: '枝もの専用設計。存在感のあるアイアン素材。',
      alt: 'アイアンスタンドに枝ものを飾った様子',
      images: [iron1, iron2, iron3, iron4, iron5, iron6],
      detail:
        '大きな枝ものを思い切り飾れるアイアンスタンドを見つけました！\n\n鉄でできているのでずっしりと重みがあり安定感抜群。小ぶりながらロングサイズの枝ものもしっかりと支えてくれます。マットなブラックにシンプルな形がいい意味で目立たず、飾った植物の魅力をきちんと引き立ててくれます。\n\nまた、筒の部分は取り外せるので、水替えも簡単。また、筒を外した状態ではドライフラワースタンドとしても使える2way仕様。汎用性の高さも嬉しいポイントです。',
      size: '高さ20cm 口径4.5cm',
      material: 'アイアン',
      notes: ['職人が一点ずつ手作業で制作しているため、色・形・大きさ等に違いが生じる場合があります', '素材の特性上、サビが発生する場合がございます'],
    },
  ]

  const isOutOfStock = (product: { name: string }) => {
    if (products?.length > 0) {
      return products.find((p) => p.attributes.name === product.name)?.attributes.on_sale === false
    } else {
      return false
    }
  }

  return (
    <section className="py-20 md:py-28 px-5">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-center text-2xl md:text-3xl font-medium text-black leading-relaxed">ぴったりの花器、あります</h2>
        <p className="mt-4 text-center text-[15px] text-main leading-relaxed max-w-md mx-auto">
          枝を活ける花器がなくても大丈夫。フローリストがセレクトした、サイズはもちろんデザインも美しいとっておきの3種類をご用意しました。
        </p>
        <div className="mt-4 flex justify-center">
          <div className="inline-block bg-accent/10 rounded-md px-4 py-2 text-center">
            <p className="text-[14px] text-accent leading-relaxed">
              お申し込み時に花器を一緒に買うと<span className="font-bold ml-1 border-b border-dotted border-accent">20%OFF</span>
            </p>
          </div>
        </div>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          {productData.map((p, i) => (
            <div
              key={i}
              className={`rounded-2xl border bg-white overflow-hidden transition-colors ${isOutOfStock(p) ? 'border-gray opacity-50 cursor-default' : 'border-gray cursor-pointer hover:border-black'}`}
              onClick={() => !isOutOfStock(p) && setSelectedVase(p)}
            >
              <div className="aspect-square overflow-hidden bg-gray/30 relative">
                <img src={p.images[0]} alt={p.alt} className="w-full h-full object-cover" />
                {isOutOfStock(p) ? (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="bg-black/70 text-white text-[13px] font-medium px-4 py-1.5 rounded-full">在庫切れ</span>
                  </div>
                ) : (
                  p.popular && (
                    <div className="absolute top-5 md:top-4 -left-8 md:-left-6 w-36 md:w-28 bg-black text-white text-[12px] md:text-[11px] font-medium text-center py-1.5 md:py-1 -rotate-45 origin-center">
                      人気No.1
                    </div>
                  )
                )}
              </div>
              <div className="p-5">
                <h4 className="text-sm font-medium text-black">{p.name}</h4>
                <p className="mt-1 text-[14px] text-main">{p.desc}</p>
                <div className="mt-2 flex items-center gap-2">
                  <p className="text-[12px] text-dark-gray line-through">
                    {p.price.replace('（税込）', '')}
                    <span className="text-[10px] ml-0.5">円</span>
                  </p>
                  <p className="text-sm font-display font-medium text-accent">
                    {p.discountPrice.replace('（税込）', '')}
                    <span className="text-[11px] ml-0.5 font-sans font-semibold">円</span>
                  </p>
                  <span className="text-[10px] border border-accent text-accent px-1.5 py-0.5 rounded-full">送料無料</span>
                </div>
                <p className="mt-3 text-[12px] text-dark-gray underline underline-offset-4">詳細を見る</p>
              </div>
            </div>
          ))}
        </div>
        <VaseModal product={selectedVase} onClose={() => setSelectedVase(null)} />
      </div>
    </section>
  )
}

function VaseModal({ product, onClose }: { product: any; onClose: () => void }) {
  const [imgIndex, setImgIndex] = useState(0)
  const images = product?.images

  useEventListener('keydown', (e) => e.key === 'Escape' && onClose())

  if (!images) return null

  return (
    <dialog
      open={!!product}
      className="fixed inset-0 w-full h-full flex items-center justify-center px-4 py-6 overlay-in bg-black/50"
      style={{ zIndex: 10000 }}
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-3xl overflow-hidden max-w-sm w-full shadow-2xl max-h-[90vh] flex flex-col modal-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative aspect-square overflow-hidden bg-gray/20 shrink-0">
          <img src={images[imgIndex]} alt={product.alt} className="w-full h-full object-cover" />
          {images.length > 1 && (
            <>
              <button
                onClick={() => setImgIndex((i) => (i - 1 + images.length) % images.length)}
                className="absolute left-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/80 flex items-center justify-center cursor-pointer"
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 12 12"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="8 2 4 6 8 10" />
                </svg>
              </button>
              <button
                onClick={() => setImgIndex((i) => (i + 1) % images.length)}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/80 flex items-center justify-center cursor-pointer"
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 12 12"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="4 2 8 6 4 10" />
                </svg>
              </button>
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
                {images.map((_: unknown, i: number) => (
                  <button
                    key={i}
                    onClick={() => setImgIndex(i)}
                    className={`w-1.5 h-1.5 rounded-full transition-colors ${i === imgIndex ? 'bg-white' : 'bg-white/50'}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>
        <button onClick={onClose} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/80 flex items-center justify-center z-10 cursor-pointer">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <line x1="2" y1="2" x2="10" y2="10" />
            <line x1="10" y1="2" x2="2" y2="10" />
          </svg>
        </button>

        <div className="overflow-y-auto p-6 space-y-5">
          <div>
            <h3 className="text-[17px] font-sans font-medium text-black">{product.name}</h3>
            <div className="mt-1 flex items-center gap-2">
              <p className="text-[14px] text-dark-gray line-through">
                {product.price.replace('（税込）', '')}
                <span className="text-[11px] ml-0.5">円</span>
              </p>
              <p className="text-[20px] font-display font-medium text-accent">
                {product.discountPrice.replace('（税込）', '')}
                <span className="text-[13px] font-normal ml-0.5">円</span>
              </p>
              <span className="text-[10px] border border-accent text-accent px-1.5 py-0.5 rounded-full">送料無料</span>
            </div>
          </div>

          <p className="text-[14px] text-main leading-[1.9] whitespace-pre-line">{product.detail}</p>

          <div className="space-y-2 pt-2 border-t border-gray/40 text-[13px]">
            {product.size && (
              <div className="flex gap-3">
                <span className="text-dark-gray shrink-0">サイズ</span>
                <span className="text-main">{product.size}</span>
              </div>
            )}
            {product.material && (
              <div className="flex gap-3">
                <span className="text-dark-gray shrink-0">素材</span>
                <span className="text-main">{product.material}</span>
              </div>
            )}
          </div>

          <ul className="space-y-1 pl-3">
            {product.notes.map((note: string, i: number) => (
              <li key={i} className="text-[12px] text-dark-gray leading-relaxed pl-1 list-['※']">
                {note}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </dialog>
  )
}
